/*
 * @Author: 赵泽文
 * @Date: 2022-05-19 11:06:04
 * @LastEditors: 赵泽文
 * @LastEditTime: 2022-05-19 11:26:47
 * @Description: 生产计划单model
 */

import type {
  IProducePlanOrderModel,
  IProducePlanOrderStore,
} from '@monorepo/types/process/productionPlan/productionPlan.types';
import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';

const initState: IProducePlanOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_type: 'CREATED_DATE',
    sort_order: 'CREATED_DESC',
    date: getToday(),
    order_state: '',
  },
  auditNo: '',
};

const productionPlanStore: IProducePlanOrderModel = {
  namespace: 'productionPlanStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return { ...state, tableList };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default productionPlanStore;
